var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.294,
    height: 14.294,
    viewBox: "0 0 14.294 14.294"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.575 7.149a.714.714 0 00-.714.714v4.287a.715.715 0 01-.714.715h-10a.714.714 0 01-.714-.715v-10a.714.714 0 01.714-.714H6.43a.715.715 0 100-1.43H2.143A2.143 2.143 0 000 2.148v10a2.143 2.143 0 002.143 2.143h10a2.143 2.143 0 002.143-2.143V7.864a.714.714 0 00-.711-.715zm-10.717.543v3.029a.714.714 0 00.714.714H6.6a.714.714 0 00.507-.207l4.944-4.951 2.029-1.986a.714.714 0 000-1.015L11.053.212a.714.714 0 00-1.015 0L8.024 2.234 3.065 7.185a.715.715 0 00-.207.507zm7.688-5.966l2.022 2.022-1.015 1.015-2.022-2.022zM4.287 7.985l4.237-4.237 2.022 2.022-4.237 4.236H4.287z",
    fill: "#1053ff"
  })));
}

export default SvgEditBlue;